import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PaymentMethodDetector from './PaymentMethodDetector';

// Pages where Stripe should be loaded
const STRIPE_REQUIRED_PAGES = [
  '/checkout',
  '/order-summary',
  '/buy',
  '/cart',
  '/profile/payment-details'
];

/**
 * Component to automatically cleanup Stripe when leaving payment pages
 * Add this component to your main App or Layout component
 */
const StripeCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const shouldKeepStripe = STRIPE_REQUIRED_PAGES.some(page =>
      currentPath.startsWith(page) || currentPath.includes(page)
    );

    // If we're not on a payment page and Stripe is loaded, clear it
    if (!shouldKeepStripe && PaymentMethodDetector.isStripeLoaded()) {
      // Add a small delay to ensure any ongoing payment operations complete
      const cleanup = setTimeout(() => {
        PaymentMethodDetector.clearStripeInstance();
      }, 1000);

      return () => clearTimeout(cleanup);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default StripeCleanup;